export default "__VITE_ASSET__CiBa$Dso__"